/**
 * 设计系统常量
 * 用于替换内联样式中的 magic numbers
 */

/** 间距比例尺 (px) */
export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  base: 16,
  lg: 20,
  xl: 24,
  '2xl': 32,
  '3xl': 40,
  '4xl': 48,
} as const;

/** 圆角比例尺 (px) */
export const RADIUS = {
  none: 0,
  sm: 4,
  md: 6,
  lg: 8,
  full: 9999,
} as const;

/** 字号比例尺 (px) */
export const FONT_SIZE = {
  xs: 12,
  sm: 13,
  base: 14,
  md: 16,
  lg: 20,
  xl: 24,
  '2xl': 28,
} as const;

/** 字重 */
export const FONT_WEIGHT = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;

/** 固定尺寸 (px) */
export const SIZE = {
  iconSm: 16,
  iconMd: 24,
  iconLg: 32,
  iconXl: 48,
  headerHeight: 64,
  selectSm: 100,
  selectMd: 120,
  selectLg: 150,
  inputSearch: 300,
} as const;

/** 业务常量 */
export const BIZ = {
  trialDays: 14,
  pollingInterval: 3000,
} as const;
